import useCopy from "./useCopy";

/**
 * The search bar's placeholder, as the homepage had it before the revamp
 * (`SearchInputHome` / `SearchModalDesktop`): "Search by" and then City, University and
 * Property in turn, on those components' keys. The phone hero rolls the words; desktop
 * and the scrolled header type them. Never empty: an empty word would stall the typewriter.
 */
const SEARCH_KEYWORDS: [key: string, english: string][] = [
  ["home.searchinputhome.searchmodaldesktop.citysuffix", "City"],
  ["home.searchinputhome.searchmodaldesktop.universitysuffix", "University"],
  ["home.searchinputhome.searchmodaldesktop.propertysuffix", "Property"],
];

const useSearchKeywords = (): string[] => {
  const copy = useCopy();
  return SEARCH_KEYWORDS.map(([key, english]) => copy(key, english));
};

export default useSearchKeywords;
